export default "__VITE_ASSET__529141bc__"